module.exports = __webpack_public_path__ + "img/58f2439.jpg";